import React from 'react';
import './Footer.css';

const Footer = ({ config }) => {
  return (
    <div className="footer">
      <div className="footer-content">
        <div className="footer-links">
          {config.links.map((link, index) => (
            <a key={index} href={link.href} className="footer-link">
              {link.label}
            </a>
          ))}
        </div>
        
        <div className="copyright">
          <p>{config.copyright}</p>
        </div>
        
        <div className="footer-logo">
          <img 
            src={config.logo} 
            alt="Nexus Living Logo" 
            className="footer-logo-img"
          />
        </div>
      </div>
    </div>
  );
};

export default Footer;
